import { ITEM_SET_STATUS_COLOR } from '@exam-management/components';
import { QuestionGroupStatus } from '@exam-management/graphql';
import { Link } from '@exam-management/router';
import {
  type ColorPalette,
  EllipsisText,
  LaunchRoundedIcon,
  Text,
  Link as BaseLink,
} from '@shared/components';

import type { Question } from '../../types';
import { QuestionInLocation } from '../question-in-location';

type ItemSetQuestion = Question;

export interface ItemSetQuestionInLocationProps {
  question: ItemSetQuestion;
  structureId: string;
  highlight?: boolean;
}

export default function ItemSetQuestionInLocation(props: Readonly<ItemSetQuestionInLocationProps>) {
  const { question, structureId, highlight: isHighlight = false } = props;

  const statusColor =
    question.status !== QuestionGroupStatus.Na
      ? ITEM_SET_STATUS_COLOR[question.status as keyof typeof ITEM_SET_STATUS_COLOR]
      : null;

  return (
    <BaseLink
      component={Link}
      to='/qbank-structures/:structureId/qcontents/item-set/:questionId'
      params={{
        structureId: structureId,
        questionId: question.id,
      }}
      target='_blank'
      rel='noreferrer'
      sx={{ lineHeight: 0, textDecoration: 'none', color: (theme) => theme.palette.text.primary }}
    >
      <QuestionInLocation
        statusColor={statusColor as ColorPalette}
        content={
          <>
            <EllipsisText variant='body2'>{question.name}</EllipsisText>
            &nbsp;
            <Text
              variant='body2'
              sx={{ minWidth: 'fit-content' }}
            >{`(${question.totalQuestions} Questions)`}</Text>
          </>
        }
        highlight={isHighlight}
        endAdornment={
          <LaunchRoundedIcon
            sx={(theme) => ({
              fontSize: '24px',
              color: theme.palette.grey[500],
              ml: theme.spacing(1),
            })}
          />
        }
      />
    </BaseLink>
  );
}
